'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:AppLicenseCtrl
 * @description
 * # AppLicenseCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('AppLicenseCtrl', ['$scope', 'AppLicense', 'Pagination', 'Client', 'ProductCatalog', 'FileSaver',
    function ($scope, AppLicense, Pagination, Client, ProductCatalog, FileSaver) {
      const SEARCH_ATTRIBUTES = {
        'search': '',
        'by_column': '',
        'filters': {
          'client_id': 'fa-sort',
          'entity_name': 'fa-sort',
          'license_type': 'fa-sort',
          'product_catalog_id': 'fa-sort',
          'license_valid_until': 'fa-sort',
          'is_active': 'fa-sort',
          'created_at': 'fa-sort-desc'
        }
      };
      $scope.search = SEARCH_ATTRIBUTES;
      $scope.searchClient = '';
      $scope.selectedClient = undefined;
      $scope.clients = [];
      $scope.products = [];
      $scope.statusList = [
        {
          name: 'Todos',
          id: ''
        },
        {
          name: 'Vencida',
          id: 'inactive'
        },
        {
          name: 'Vigente',
          id: 'active'
        },
      ];
      $scope.licenseTypeList = [
        {
          name: 'Todos',
          id: ''
        },
        {
          name: 'Usuarios Concurrentes',
          id: 'concurrent_users'
        },
        {
          name: 'Usuarios Nombrados',
          id: 'named_users'
        },
      ];

      $scope.selectedStatus = $scope.statusList[0];
      $scope.selectedLicenseType = $scope.licenseTypeList[0];
      $scope.selectedClient = {
        name: '',
        id: ''
      };
      $scope.selectedProduct = {
        name: '',
        id: ''
      };

      $scope.app_licenses = {
        list: [],
        pager: {}
      };

      $scope.getPage = (page) => {
        var params = {
          params: {
            page: page,
            per_page: 10,
            search: $scope.search.search,
            by_column: $scope.search.by_column,
            by_client: $scope.selectedClient.id,
            by_product_catalog: $scope.selectedProduct.id,
            by_license_type: $scope.selectedLicenseType.id,
            by_status: $scope.selectedStatus.id
          }
        };
        AppLicense.index(params).then((response) => {
          $scope.app_licenses.list = response.data.app_licenses;
          $scope.app_licenses.pager = Pagination.GetPager(
            response.data.meta.pagination.total_objects,
            page,
            response.data.meta.pagination.per_page);

        }, (error) => {
          AppLicense.error(error);
        });
      };

      $scope.clearSearch = () => {
        $scope.search = SEARCH_ATTRIBUTES;
        $scope.getPage(1);
      }

      $scope.filter = (column) => {
        let order = '';
        angular.forEach($scope.search.filters, (value, key) => {
          if (column === key) {
            if ($scope.search.filters[key] === 'fa-sort-desc') {
              $scope.search.filters[key] = 'fa-sort-asc';
              order = 'ASC';
            } else {
              $scope.search.filters[key] = 'fa-sort-desc';
              order = 'DESC';
            }
          } else {
            $scope.search.filters[key] = 'fa-sort';
          }
        });
        $scope.search.by_column = {
          column: column,
          order: order
        };
        $scope.getPage(1);
      };

      $scope.downloadAppLicense = (event, app_license) => {
        event.stopPropagation();

        AppLicense.downloadAppLicense(app_license.id).then((res) => {
          var blob = new Blob([res.data], { type: 'application/sql;charset=utf-8;' });
          FileSaver.saveAs(blob, 'LicenseScript.sql');
        }).catch((err) => {
          AppLicense.error(err);
        });
      }

      $scope.clientSearch = (searchQuery) => {
        if (!searchQuery) {
          return $scope.clients;
        }
        let clients = $scope.clients.filter(client => client.name.includes(searchQuery));

        return clients;
      };

      const getAllParams = () => {
        const productPromise = ProductCatalog.index({ params: { per_page: 'all', by_column: { "column": "name", "order": "ASC" } } }).then((response) => {
          $scope.products = response.data.products;
          $scope.products.unshift({ name: "TODOS", id: '' });
          $scope.selectedProduct = $scope.products[0];

          return;
        }).catch((error) => {
          // TODO: Show the notification that the clients were unable to get
          console.log(error);
        });

        const clientPromise = Client.index({ params: { per_page: 'all', by_column: { "column": "name", "order": "ASC" } } }).then((response) => {
          $scope.clients = response.data.clients;
          $scope.clients.unshift({ name: 'TODOS', id: '' });
          $scope.selectedClient = $scope.clients[0];

          return;
        }).catch((error) => {
          // TODO: Show the notification that the clients were unable to get
          console.log(error);
        });

        return Promise.all([productPromise, clientPromise]);
      }

      // START MAIN
      getAllParams().then(() => {
        $scope.pager = {};
        $scope.getPage(1);
      })
        .catch((err) => {
          console.log(err);
        });
    }]);
